import React, { useState, useEffect } from 'react'
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  Button,
  Table,
  Modal,
  InputNumber,
  Dropdown,
  Menu,
  Tooltip,
} from 'antd'

import styled from 'styled-components'
import ColorList from 'constants/color.constants'
import {
  LeftOutlined,
  RightOutlined,
  PlusOutlined,
  CloseCircleOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons'
import more from 'icons/More.svg'
import { getCookie } from 'helper/cookie'

import {
  getResultKPIFinance,
  addKPIFinance,
  getKpiSearch,
  getKpiType,
  getUnitType,
} from 'api/Project/kpifinance'
import emptyKPI from 'icons/createproject/Subtask.svg'
import { useForm } from 'antd/lib/form/Form'

import FormatNumber from 'common/FormatNumber/money'
import lang from 'lang/en'
import { ButtonPrimaryOutlineNoBackgroundStyle } from 'common/Button/button.styles'

import ModalMinMax from 'common/KPIFinance/modalMinMax'
import ModalTaskGoals from 'common/KPIFinance/modalTaskGoals'
import ModalAdd from 'common/KPIFinance/modalAddKPI'
import ModalDelete from 'common/KPIFinance/modalDelete'

import NoPermission from 'common/KPIFinance/noPermissionKPI'

import FormatMinMax from 'common/FormatNumber/minmax'

// import 'styleLess/signature/taskKPIFinance.scss'

const Container = styled.div`
  // background-color: ${ColorList.white};

  // width: 100;
  // height: auto;
  margin-top: 32px;
  // margin-left: 4px;
`
const ConatainerKPI = styled.div``
const SubContainer = styled.div``
const Header = styled.div``
const EmptyState = styled.div``
const Footer = styled.div``
const ContainerCard = styled.div``
const CardItem = styled.div``
const LeftCard = styled.div``
const RightCard = styled.div``

const initalState = {
  data: [],
  isLoading: true,
}
let render = ''
let render2 = ''
let render3 = ''
const AddSubTaskKPIFinance = (props) => {
  const {
    swithCaseTaskFLowFunction,
    role,
    idEditPRJ,
    statusProject,
    id,
    idsubtask,
    canKPIFinance,
  } = props
  const [checkBtn, setCheckBtn] = useState('')
  const [visibleRegister, setVisibleRegister] = useState(true)
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')
  const [dataKPIFinance, setDataKPIFinance] = useState(initalState.data)

  const language = getCookie('lang')
  const word = lang[language]

  //Modal
  const [visibleDelete, setVisibleDelete] = useState(false)
  const [visableModal, setVisableModal] = useState(false)
  const [typeBtn, setTypeBtn] = useState(false)
  const [visableModalTaskGoals, setVisableModalTaskGoals] = useState(false)
  const [visableModalMinMax, setVisableModalMinMax] = useState(false)

  //add goal project
  const [dataProject, setDataProject] = useState(initalState.data)
  const [dataTask, setDataTask] = useState(initalState.data)
  const [dataSubTask, setSubDataTask] = useState(initalState.data)
  const [dataDeleteTask, setDataDeleteTask] = useState(initalState.data)
  const [dataEditTask, setDataEditTask] = useState(initalState.data)
  const [typeState, setTypeState] = useState()

  const getKPIFinance = async () => {
    const dataArray = {
      project_id: idEditPRJ,
      sprintflow_id: `${idsubtask}`,
    }

    getKpiSearch({
      token: token,
      params: dataArray,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataKPIFinance([])
          setDataTask([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataKPIFinance(data.projects)

          if (data.projects == '' || data.projects == null) {
            render = ''
          } else {
            render = '1'
          }

          if (data.tasks == '' || data.tasks == null) {
            render2 = ''
          } else {
            render2 = '1'
          }
          if (data.subtasks != null) {
            render3 = '1'
          } else {
            render3 = ''
          }

          setDataTask(data.tasks)
          setSubDataTask(data.subtasks)
        } else {
          setDataKPIFinance([])
          setDataTask([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataKPIFinance([])
        setDataTask([])
        setIsLoading(false)
        console.error(error)
      })
  }

  useEffect(() => {
    if (token) {
      render = ''
      render2 = ''
      render3 = ''
      getKPIFinance()
    }
  }, [token])

  const modalDelete = (item) => {
    setVisibleDelete(true)
    setDataDeleteTask(item.id)
  }

  const modalEdit = (item) => {
    setDataEditTask(item)
    onClickShowModal('edit')
  }

  const menu = (item) => {
    return (
      <Menu>
        <Menu.Item key="0" onClick={() => modalEdit(item)}>
          {word['addtask_kpi_menu_edit']}
        </Menu.Item>
        <Menu.Item key="1" onClick={() => modalDelete(item)}>
          {word['addtask_kpi_menu_delete']}
        </Menu.Item>
      </Menu>
    )
  }

  const showModal = () => {
    return (
      <div>
        <ModalAdd
          visableModal={visableModal}
          setVisableModal={setVisableModal}
          idEditPRJ={idEditPRJ}
          typeBtn={typeBtn}
          getResultKpi={getKPIFinance}
          stateKPI={idsubtask}
          dataEdit={dataEditTask}
          titlePage="Sub Task"
        />

        <ModalTaskGoals
          idEditPRJ={idEditPRJ}
          setVisableModalTaskGoals={setVisableModalTaskGoals}
          visableModalTaskGoals={visableModalTaskGoals}
          data={dataProject}
          idtask={idsubtask}
          getResultKpi={getKPIFinance}
          type="Sub"
        />

        <ModalMinMax
          idEditPRJ={idEditPRJ}
          setVisableModalMinMax={setVisableModalMinMax}
          visableModalMinMax={visableModalMinMax}
          data={dataProject}
          idtask={idsubtask}
          getResultKpi={getKPIFinance}
          type="Sub"
          typeState={typeState}
        />

        <ModalDelete
          visibleDelete={visibleDelete}
          setVisibleDelete={setVisibleDelete}
          idEditPRJ={idEditPRJ}
          idKPI={dataDeleteTask}
          getResultKpi={getKPIFinance}
        />
      </div>
    )
  }

  const onClickShowModal = (type) => {
    setVisableModal(true)
    setTypeBtn(type)
  }

  //check input type
  // older condition for type project item.sprintflow_parent_max, item.sprintflow_parent_goal more than zero */
  const checkInputTypeShowmodal = (inputType, item, type) => {
    setTypeState(type)
    if (inputType == 22) {
      setVisableModalMinMax(true)
      setDataProject(item)
    } else {
      setVisableModalTaskGoals(true)
      setDataProject(item)
    }
  }

  const checkShowInputTypeTask = (inputType, item) => {
    if (inputType == 22) {
      if ((item.sprintflow_min == 0) & (item.sprintflow_max == 0)) {
        return (
          <div>
            <span className="small">{word['addtask_kpi_title_subtaskgoalminmax']}</span>
            <p>-</p>
          </div>
        )
      }
      return (
        <div>
          <span className="small">{word['addtask_kpi_title_subtaskgoalminmax']}</span>
          <p>
            <FormatMinMax num={item.sprintflow_min} /> -{' '}
            <FormatMinMax num={item.sprintflow_max} /> {item.unit_type_name}
          </p>
        </div>
      )
    } else {
      if (item.sprintflow_goal == 0) {
        return (
          <div>
            <span className="small">{word['addtask_kpi_title_subtaskgoalunit']}</span>
            <p>-</p>
          </div>
        )
      } else {
        return (
          <div>
            <span className="small">{word['addtask_kpi_title_subtaskgoalunit']}</span>
            <p>
              {<FormatNumber num={item.sprintflow_goal} />} {item.unit_type_name}
            </p>
          </div>
        )
      }
    }
  }

  const checkInputTypeProject = (inputType, item, type) => {
    if (inputType == 22) {
      if (type == 'project') {
        return (
          <div>
            <span className="small">{word['addtask_kpi_title_projectgoalminmax']}</span>
            <p>
              <FormatMinMax num={item.min} /> - <FormatMinMax num={item.max} />{' '}
              {item.unit_type_name}
            </p>
          </div>
        )
      } else {
        return (
          <div>
            <span className="small">{word['addtask_kpi_title_taskgoalminmax']}</span>
            <p>
              <FormatMinMax num={item.min} /> - <FormatMinMax num={item.max} />{' '}
              {item.unit_type_name}
            </p>
          </div>
        )
      }
    } else {
      if (type == 'project') {
        return (
          <div>
            <span className="small">{word['addtask_kpi_title_projectgoalunit']}</span>
            <p>
              {<FormatNumber num={item.goal} />} {item.unit_type_name}
            </p>
          </div>
        )
      } else {
        return (
          <div>
            <span className="small">{word['addtask_kpi_title_taskgoalunit']}</span>
            <p>
              {<FormatNumber num={item.goal} />} {item.unit_type_name}
            </p>
          </div>
        )
      }
    }
  }

  const checkShowTaskGoals = (type, item) => {
    if (type == 22) {
      if (item.sprintflow_parent_max == 0) {
        return (
          <div>
            <span className="small">{word['addtask_kpi_title_taskgoalminmax']}</span>
            <Row>
              <div>
                <p>0</p>
              </div>
              <div style={{ marginLeft: 8 }}>
                <Tooltip
                  placement="rightTop"
                  title={'Enter task min-max before subtask min-max'}
                >
                  <ExclamationCircleOutlined className="ExclamationCircleOutlined" />
                </Tooltip>
              </div>
            </Row>
          </div>
        )
      } else {
        return (
          <div>
            <span className="small">{word['addtask_kpi_title_taskgoalminmax']}</span>
            <p>
              <FormatMinMax num={item.sprintflow_parent_min} /> -{' '}
              <FormatMinMax num={item.sprintflow_parent_max} /> {item.unit_type_name}
            </p>
          </div>
        )
      }
    } else {
      if (item.sprintflow_parent_goal == 0) {
        return (
          <div>
            <span className="small">{word['addtask_kpi_title_taskgoalunit']}</span>
            <Row>
              <div>
                <p>0</p>
              </div>
              <div style={{ marginLeft: 8 }}>
                <Tooltip
                  placement="rightTop"
                  title={'Enter task goals before subtask goals'}
                >
                  <ExclamationCircleOutlined className="ExclamationCircleOutlined" />
                </Tooltip>
              </div>
            </Row>
          </div>
        )
      } else {
        return (
          <div>
            <span className="small">{word['addtask_kpi_title_taskgoalunit']}</span>
            <p>
              {<FormatNumber num={item.sprintflow_parent_goal} />} {item.unit_type_name}
            </p>
          </div>
        )
      }
    }
  }

  const checkShowRemaining = (inputtype, item, type) => {
    if (type == 'project') {
      if (inputtype == 22) {
        if (item.sprintflow_parent_max == 0) {
        } else {
          return (
            <div>
              <span className="small">{word['addtask_kpi_title_remaining']}</span>
              <p>-</p>
            </div>
          )
        }
      } else {
        if (item.sprintflow_parent_goal == 0) {
        } else {
          return (
            <div>
              <span className="small">{word['addtask_kpi_title_remaining']}</span>
              <p>
                <FormatNumber
                  num={item.sprintflow_parent_goal - item.sprintflow_usegoal}
                />{' '}
                {item.unit_type_name}
              </p>
            </div>
          )
        }
      }
    } else {
      if (inputtype == 22) {
        return <p>-</p>
      } else {
        return (
          <p>
            <FormatNumber num={item.goal - item.sprintflow_usegoal} />{' '}
            {item.unit_type_name}
          </p>
        )
      }
    }
  }

  const showProject = () => {
    return (
      <div>
        <Header className="header">
          <h2 className="edit-color-h2-kpi">{word['addtask_kpi_title_projectkpi']}</h2>
        </Header>
        <SubContainer className="sub-container">
          <ContainerCard className="containerCard">
            {dataKPIFinance &&
              dataKPIFinance.map((item) => {
                return (
                  <CardItem className="card">
                    <LeftCard className="left-card">
                      <div>
                        <span className="small">
                          {word['addtask_kpi_title_kpifinance']}
                        </span>
                        <p>{item.name}</p>
                      </div>

                      <Row className="KPITypeProjectGoal">
                        <div className="KPIType">
                          <span className="small">
                            {word['addtask_kpi_title_kpitype']}
                          </span>
                          <p>{item.kpi_type_name_en}</p>
                        </div>
                        <div className="ProjectGoal">
                          {checkInputTypeProject(item.input_type_id, item, 'project')}
                        </div>
                      </Row>

                      <Row className="KPITypeProjectGoal">
                        <div className="KPIType">
                          {checkShowTaskGoals(item.input_type_id, item)}
                        </div>
                        <div className="ProjectGoal">
                          {checkShowRemaining(item.input_type_id, item, 'project')}
                        </div>
                      </Row>

                      <Row>
                        {/* taskgoal */}
                        {/* <div style={{ maxWidth: 173 }}></div> */}
                        {/* subtaskgoal */}
                        {/* <div style={{ marginLeft: 0 }}> */}
                        {checkShowInputTypeTask(item.input_type_id, item)}
                        {/* </div> */}
                      </Row>
                      <div
                        style={{
                          display: 'flex',
                          marginLeft: 350,
                          marginTop: -30,
                          alignItems: 'flex-end',
                        }}
                      >
                        <a hidden={role}>
                          <EditOutlined
                            style={{ color: '#7C7C84' }}
                            onClick={() =>
                              checkInputTypeShowmodal(item.input_type_id, item, 'project')
                            }
                          />
                        </a>
                      </div>
                    </LeftCard>
                  </CardItem>
                )
              })}
          </ContainerCard>
        </SubContainer>
      </div>
    )
  }

  const showTask = () => {
    return (
      <div>
        <Header className="header">
          <h2 className="edit-color-h2-kpi">{word['addtask_kpi_title_taskkpi']}</h2>
          {/* <Button
            className="BTN_ClassA"
            onClick={() => onClickShowModal('add')}
            icon={<PlusOutlined className="Icon-color" />}
          >
            Add Task KPI/Finance
          </Button> */}
        </Header>
        <SubContainer className="sub-container-subtask">
          <ContainerCard className="containerCard">
            {dataTask &&
              dataTask.map((item) => {
                return (
                  <CardItem className="card">
                    <LeftCard className="left-card">
                      <div>
                        <span className="small">
                          {word['addtask_kpi_title_kpifinance']}
                        </span>
                        <p>{item.name}</p>
                      </div>

                      <Row className="KPITypeProjectGoal">
                        <div className="KPIType">
                          <span className="small">
                            {word['addtask_kpi_title_kpitype']}
                          </span>
                          <p>{item.kpi_type_name_en}</p>
                        </div>
                        <div className="ProjectGoal">
                          {checkInputTypeProject(item.input_type_id, item, 'task')}
                        </div>
                      </Row>

                      <Row>
                        <div className="KPIType">
                          <span className="small">
                            {word['addtask_kpi_title_remaining']}
                          </span>
                          {checkShowRemaining(item.input_type_id, item, 'task')}
                        </div>
                        <div
                          className="ProjectGoal"
                          style={{ display: 'flex', justifyContent: 'space-between' }}
                        >
                          {checkShowInputTypeTask(item.input_type_id, item)}
                          <a
                            style={{
                              display: 'flex',
                              alignItems: 'flex-end',
                            }}
                            hidden={role}
                          >
                            <EditOutlined
                              id="edit"
                              style={{ color: '#7C7C84' }}
                              onClick={() =>
                                checkInputTypeShowmodal(item.input_type_id, item, 'task')
                              }
                            // onClick={() => setVisableModalTaskGoals(true)}
                            />
                          </a>
                        </div>
                      </Row>
                    </LeftCard>
                  </CardItem>
                )
              })}
          </ContainerCard>
        </SubContainer>
      </div>
    )
  }

  const emptyProject = () => {
    return (
      <ConatainerKPI className="containerKPI-Task">
        {/* {btnStatus()} */}
        <Header className="header">
          <h2 className="edit-color-h2-kpi">{word['addtask_kpi_title_emptyproject']}</h2>
        </Header>
        <SubContainer className="sub-container">
          <EmptyState className="empty-kpi">
            <img src={emptyKPI} />
            <h2 style={{ marginTop: 20 }}>{word['addtask_kpi_title_emptystate']}</h2>
            {/* <Button
        className="BTN_ClassA"
        onClick={() => onClickShowModal('add')}
        icon={<PlusOutlined className="Icon-color" />}
      >
        Add New Task KPI/Finance
      </Button> */}
          </EmptyState>
          {/* {footer()} */}
        </SubContainer>
      </ConatainerKPI>
    )
  }

  const emptyTask = () => {
    return (
      <ConatainerKPI className="containerKPI-Task">
        {/* {btnStatus()} */}
        <Header className="header">
          <h2 className="edit-color-h2-kpi">{word['addtask_kpi_title_emptytask']}</h2>
          {/* <Button
            className="BTN_ClassA"
            onClick={() => onClickShowModal('add')}
            icon={<PlusOutlined className="Icon-color" />}
          >
            Add New Task KPI/Finance
          </Button> */}
        </Header>
        <SubContainer className="sub-container">
          <EmptyState className="empty-kpi">
            <img src={emptyKPI} />
            <h2 style={{ marginTop: 20 }}>{word['addtask_kpi_title_emptystate']}</h2>
          </EmptyState>
          {/* {footer()} */}
        </SubContainer>
      </ConatainerKPI>
    )
  }

  if (canKPIFinance == false) {
    return <NoPermission />
  } else if (render === '1' && render2 == '' && render3 == '') {
    return (
      <Container>
        <ConatainerKPI className="containerKPI-Task">
          {showProject()} {emptyTask()}
          {/* {emptySubTask()} */}
        </ConatainerKPI>
        {showModal()}
      </Container>
    )
  } else if (render === '' && render2 == '1' && render3 == '') {
    return (
      <Container>
        <ConatainerKPI className="containerKPI-Task">
          {emptyProject()} {showTask()}
          {/* {emptySubTask()} */}
        </ConatainerKPI>
        {showModal()}
      </Container>
    )
  } else if (render === '' && render2 == '' && render3 == '1') {
    return (
      <Container>
        <ConatainerKPI className="containerKPI-Task">
          {emptyProject()} {emptyTask()}
          {/* {showSubTask()} */}
        </ConatainerKPI>
        {showModal()}
      </Container>
    )
  } else if (render === '1' && render2 == '1' && render3 == '') {
    return (
      <Container>
        <ConatainerKPI className="containerKPI-Task">
          {showProject()} {showTask()}
          {/* {emptySubTask()} */}
        </ConatainerKPI>
        {showModal()}
      </Container>
    )
  } else if (render === '' && render2 == '1' && render3 == '1') {
    return (
      <Container>
        <ConatainerKPI className="containerKPI-Task">
          {emptyProject()} {showTask()}
          {/* {showSubTask()} */}
        </ConatainerKPI>
        {showModal()}
      </Container>
    )
  } else if (render === '1' && render2 == '' && render3 == '1') {
    return (
      <Container>
        <ConatainerKPI className="containerKPI-Task">
          {showProject()} {emptyTask()}
          {/* {showSubTask()} */}
        </ConatainerKPI>
        {showModal()}
      </Container>
    )
  } else if (render === '1' && render2 == '1' && render3 == '1') {
    return (
      <Container>
        <ConatainerKPI className="containerKPI-Task">
          {showProject()} {showTask()}
          {/* {showSubTask()} */}
        </ConatainerKPI>
        {showModal()}
      </Container>
    )
  } else {
    return (
      <Container>
        {emptyProject()}
        {emptyTask()}
        {/* {emptySubTask()} */}
        {showModal()}
      </Container>
    )
  }
}
export default AddSubTaskKPIFinance
